module.exports = __webpack_public_path__ + "img/feature_buy_zh.4c8594c0.png";